<template>
  <th class="has-text-grey-light is-hidden-mobile">
    <input
      class="is-checkradio"
      :id="inputId"
      type="checkbox"
      :checked="checked"
      @change="$emit('change', $event)"
    >
    <label :for="inputId"></label>
  </th>
</template>

<script>
export default {
  name: 'BulkSelectAllHeader',

  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    inputId() {
      return 'bulk-select-all-' + this._uid
    }
  }
}
</script>
